import { useCallback, useEffect, useState } from "react";

export function useGameNotice() {
  const [notice, setText] = useState("");
  const [revision, setRevision] = useState(0);
  const setNotice = useCallback((message: string) => {
    setText(message);
    setRevision(value => value + 1);
  }, []);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setText(""), 6500);
    return () => window.clearTimeout(timer);
  }, [notice, revision]);
  return { notice, setNotice };
}
